import { createTRPCClient, httpBatchLink, TRPCClientError, type TRPCClient } from '@trpc/client';
import type { CompradorAppRouter } from '@ama/api';
import { sessaoCompradorAtual, salvarSessaoComprador } from './compradorAuth';

/** Header pelo qual o backend devolve a sessão renovada (renovação deslizante). */
const HEADER_SESSAO_RENOVADA = 'x-comprador-sessao';

/**
 * Cliente tRPC do app do comprador — endpoint SEPARADO (`/trpc-comprador`),
 * mesmo padrão de `lib/trpc.ts` (link único, header por requisição), mas SEM
 * Clerk: o token vem do localStorage, escopado pelo slug da incorporadora
 * atual (setado pelo shell do comprador ao montar, ver components/comprador).
 */
let slugAtual: string | null = null;

export function setSlugCompradorAtual(slug: string | null): void {
  slugAtual = slug;
}

export const compradorTrpc: TRPCClient<CompradorAppRouter> = createTRPCClient<CompradorAppRouter>({
  links: [
    httpBatchLink({
      url: '/trpc-comprador',
      headers() {
        const h: Record<string, string> = {};
        const token = slugAtual ? sessaoCompradorAtual(slugAtual) : null;
        if (token) h.Authorization = `Bearer ${token}`;
        return h;
      },
      // Renovação DESLIZANTE: se a resposta traz um token novo (o backend
      // reemite quando o atual já tem mais de um dia), regrava no localStorage.
      // Assim a sessão de 90 dias se estende a cada uso — o comprador só volta
      // ao login por dispositivo novo, 90 dias parado ou "Sair".
      async fetch(url, opts) {
        const res = await fetch(url, opts);
        const novo = res.headers.get(HEADER_SESSAO_RENOVADA);
        if (novo && slugAtual) salvarSessaoComprador(slugAtual, novo);
        return res;
      },
    }),
  ],
});

export function isCompradorTRPCError(err: unknown): err is TRPCClientError<CompradorAppRouter> {
  return err instanceof TRPCClientError;
}
